"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("@firebase/util");
var TransactionResult = /** @class */ (function () {
 /**
 * A type for the resolve value of Firebase.transaction.
 * @constructor
 * @dict
 * @param {boolean} committed
 * @param {DataSnapshot} snapshot
 */
 function TransactionResult(committed, snapshot) {
 this.committed = committed;
 this.snapshot = snapshot;
 }
 // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
 // for end-users
 TransactionResult.prototype.toJSON = function () {
 util_1.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
 return { committed: this.committed, snapshot: this.snapshot.toJSON() };
 };
 return TransactionResult;
}());
exports.TransactionResult = TransactionResult;

//# sourceMappingURL=TransactionResult.js.map



//////////////////
// WEBPACK FOOTER
// ../database/dist/cjs/src/api/TransactionResult.js
// module id = 82
// module chunks = 0